import { Component, OnInit } from '@angular/core';
import { Platform, NavController, NavParams, MenuController } from 'ionic-angular';
import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';

import { AuthService } from '../../app/shared/services/auth.service';
import { ElementsService } from '../../app/shared/services/elements.service';
import { LastScansService } from '../../app/shared/services/lastScans.service';

import { HomepageComponent } from '../home/home';
import { ListeElementsVerifiesComponent } from '../liste-elements-verifies/liste-elements-verifies';
import { ListeObservationsVerifiesComponent } from '../liste-observations-verifies/liste-observations-verifies';

@Component({
  selector: 'page-element-verifie',
  templateUrl: './element-verifie.html'
})
export class ElementVerifieComponent implements OnInit {
    loader: boolean = true;
    element: any = {};
    equipmentId: number;
    rapportId: number;
    listeElementsVerifies = [];
    num: number;
    token: any = {};
    
    constructor(
        private iab: InAppBrowser,
        private platform: Platform,
        private ga: GoogleAnalytics,
        private navCtrl: NavController,
        private menuCtrl: MenuController,
        private authService: AuthService,
        private elementsService: ElementsService,
        private lastScansService: LastScansService,
        private navParams: NavParams
    ) {
        this.platform.ready().then(() => {
            this.ga.trackView("Elément vérifié");
        });
    }

    ngOnInit(): any {
        this.init();
    }

    async init(): Promise<any> {
        this.equipmentId = this.navParams.get("equipmentId") || 0;
        this.rapportId = this.navParams.get("rapportId") || 0;
        this.listeElementsVerifies = this.navParams.get("listeElementsVerifies") || [];
        this.num = this.navParams.get("elementVerifie") || 0;
        
        if (this.equipmentId === 0 && this.rapportId === 0 && this.listeElementsVerifies.length === 0) {
            const liste = await this.lastScansService.getLastScans();
            const token = await this.authService.getToken();
            if (liste !== null) {
                for (let i in liste) {
                    if (liste[i].user == token.user) {
                        this.element = liste[i].scans[0].data;
                        this.loader = false;
                    }
                }
            }
        } else if (this.listeElementsVerifies == undefined) {
            this.getElement();
        } else {
            this.element = this.listeElementsVerifies[this.num];
            this.loader = false;
        }
    }
    
    getElement(): any {
        this.elementsService.getElementVerify(this.equipmentId, this.rapportId).subscribe( (element: any) => {
                this.element = element;
                this.loader = false;
            },
            async (error: any) => {
                console.error(error);
                if (error.status == 401 && !this.authService.refreshCalled) {
                    this.authService.refreshCalled = true;
                    const refreshToken = await this.authService.getRefreshToken();
                    if (refreshToken == null) {
                        await this.authService.removeToken();
                        await this.authService.removeRefreshToken();
                        this.menuCtrl.enable(true, 'unauthenticated');
                        this.menuCtrl.enable(false, 'authenticated');
                        this.navCtrl.setRoot(HomepageComponent);
                    } else {
                        this.authService.refresh(refreshToken).subscribe(async (data: any) => {
                            const token = await this.authService.getToken()
                            await this.authService.setToken(token.user, data.access_token, data.statut);
                            await this.authService.setRefreshToken(data.refresh_token)
                            this.navCtrl.setRoot(ElementVerifieComponent, { rapportId: this.rapportId });
                        });
                    }
                } else {
                    this.authService.refreshCalled = false;
                    this.navCtrl.setRoot(HomepageComponent);
                }
            }
        );
    }

    swipeEvent(e: any): any {
        if (this.listeElementsVerifies != undefined) {
            if (e.direction == 2) {
                if (this.listeElementsVerifies.length <= this.num + 1) {
                    this.num = 0;
                } else {
                    this.num++;
                }
                this.navCtrl.push( ElementVerifieComponent,
                    { "listeElementsVerifies": this.listeElementsVerifies, "elementVerifie": this.num },
                    { animate: true, direction: 'forward' }
                );
            }
            else if (e.direction == 4) {
                if (0 > this.num - 1) {
                    this.num = this.listeElementsVerifies.length - 1;
                } else {
                    this.num--;
                }
                this.navCtrl.push(
                    ElementVerifieComponent,
                    { "listeElementsVerifies": this.listeElementsVerifies, "elementVerifie": this.num },
                    { animate: true, direction: 'back' }
                );
            }
        }
    }

    goToListeObservations(equipementId: number, rapportId: number): any {
        this.navCtrl.push(ListeObservationsVerifiesComponent, { equipementId: equipementId, rapportId: rapportId });
    }

    goToPdf(element: any): any {
        this.iab.create(encodeURI(element.pdfURL), '_system', 'location=yes');
    }

    goToListeElementsVerifies(rapportId: number): any {
        this.navCtrl.push(ListeElementsVerifiesComponent, { rapportId: rapportId });
    }

    isEmptyObject(obj: any): any {
        return (obj && (Object.keys(obj).length === 0));
    }
}


// WEBPACK FOOTER //
// ./src/pages/element-verifie/element-verifie.ts